/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Subtitle_Export_Preset_Save_FailedInputs */



/**
* | output |
* | --- |
* | "Failed to save preset: {error}" |
*
* @param {Subtitle_Export_Preset_Save_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_preset_save_failed = /** @type {((inputs: Subtitle_Export_Preset_Save_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Preset_Save_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Échec de l'enregistrement du préréglage : ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Voreinstellung konnte nicht gespeichert werden: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Impossibile salvare il preset: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Не удалось сохранить предустановку: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`No se pudo guardar el ajuste preestablecido: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`保存预设失败：${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`プリセットの保存に失敗しました: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`प्रीसेट सहेजने में विफल: ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Falha ao salvar a predefinição: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Failed to save preset: ${i?.error}`)
});